"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useCallback, useContext, useMemo, useRef } from "react";
type ScrollHandler = (serialNo: number) => void;
interface ScrollRequest {
  readonly waveId: string;
  readonly serialNo: number;
}
interface RegisteredHandler {
  readonly waveId: string;
  readonly handler: ScrollHandler;
}
interface WaveChatScrollContextValue {
  readonly requestScrollToSerialNo: (request: ScrollRequest) => void;
  readonly registerScrollHandler: (registration: RegisteredHandler) => () => void;
}
const WaveChatScrollContext = createContext<WaveChatScrollContextValue | null>(null);
export function WaveChatScrollProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const registeredHandlerRef = useRef(null);
  const pendingRequestRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = request => {
      const registered = registeredHandlerRef.current;
      if (registered && registered.waveId === request.waveId) {
        registered.handler(request.serialNo);
        return;
      }
      pendingRequestRef.current = request;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const requestScrollToSerialNo = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = registration => {
      registeredHandlerRef.current = registration;
      const pending = pendingRequestRef.current;
      if (pending && pending.waveId === registration.waveId) {
        pendingRequestRef.current = null;
        registration.handler(pending.serialNo);
      }
      return () => {
        const current = registeredHandlerRef.current;
        if (current && current.waveId === registration.waveId && current.handler === registration.handler) {
          registeredHandlerRef.current = null;
        }
      };
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const registerScrollHandler = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      requestScrollToSerialNo,
      registerScrollHandler
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const value = t3;
  let t4;
  if ($[3] !== children) {
    t4 = <WaveChatScrollContext.Provider value={value}>{children}</WaveChatScrollContext.Provider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export function useWaveChatScrollOptional() {
  return useContext(WaveChatScrollContext);
}